var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 442 166.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#0078e3;}.cls-3{fill:url(#New_Gradient_Swatch_2);}.cls-4{clip-path:url(#clippath);}.cls-5{fill:none;}.cls-6{fill:url(#radial-gradient);opacity:.9;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 22.84,
    width: 413.1,
    height: 120.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_2",
    cx: 383.34,
    cy: 196.69,
    fx: 383.34,
    fy: 196.69,
    r: 149.97,
    gradientTransform: "translate(-339.62 -121.24) scale(1.43 .62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#009ae2",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0092e2",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0085e2",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078e3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 432.7,
    cy: 180.59,
    fx: 432.7,
    fy: 180.59,
    r: 194.13,
    gradientTransform: "translate(-17.81 -87.35) scale(1.03 .93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e30567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#db086b",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#c51377",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#a2258a",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#703ea5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#325ec7",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078e3",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 442,
    height: 166.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 22.84,
    width: 413.1,
    height: 120.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 207.28,
    cy: 1.32,
    rx: 289.3,
    ry: 129.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 429.46,
    cy: 81.44,
    rx: 271.34,
    ry: 208.53
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.16,81.66c0-16.07,12.7-28.56,28.56-28.56s28.67,12.48,28.67,28.56-12.81,28.56-28.67,28.56-28.56-12.49-28.56-28.56Zm47.77,0c0-10.97-8.36-19.33-19.22-19.33s-19.11,8.35-19.11,19.33,8.36,19.33,19.11,19.33,19.22-8.36,19.22-19.33Zm-106.33,0c0-16.07,12.16-28.56,28.56-28.56,10.75,0,19.87,5.64,24,14.22l-7.93,4.55c-2.72-5.76-8.8-9.55-16.07-9.55-10.86,0-19.11,8.35-19.11,19.33s8.25,19.21,19.11,19.21c7.39,0,13.35-3.79,16.39-9.44l8.04,4.67c-4.56,8.47-13.79,14.12-24.43,14.12-16.39,0-28.56-12.49-28.56-28.56Zm-8.29,0c0,16.06-12.38,28.56-27.47,28.56-9.23,0-16.17-4.13-20.52-10.75v25.8h-9.45V54.51h9.45v9.34c4.35-6.63,11.29-10.75,20.52-10.75,15.1,0,27.47,12.48,27.47,28.56Zm-9.45,0c0-11.08-8.36-19.44-19.22-19.44s-19.33,8.36-19.33,19.44,8.36,19.43,19.33,19.43,19.22-8.36,19.22-19.43Zm-85.05,19.65c7.49,0,12.92-3.47,15.63-7.93l8.04,4.56c-4.78,7.38-13.03,12.27-23.89,12.27-17.48,0-29.1-12.27-29.1-28.56s11.51-28.56,28.45-28.56,27.03,13.46,27.03,28.66c0,1.41-.11,2.82-.33,4.23h-45.49c1.85,9.77,9.56,15.31,19.65,15.31Zm-19.65-23.56h36.26c-1.63-10.75-9.34-15.75-17.48-15.75-10.21,0-17.27,6.29-18.79,15.75Zm-17.95,3.91c0,16.06-12.38,28.56-27.47,28.56-9.23,0-16.17-4.13-20.52-10.75v25.8h-9.45V54.51h9.45v9.34c4.35-6.63,11.29-10.75,20.52-10.75,15.1,0,27.47,12.48,27.47,28.56Zm-9.45,0c0-11.08-8.36-19.44-19.22-19.44s-19.33,8.36-19.33,19.44,8.36,19.43,19.33,19.43,19.22-8.36,19.22-19.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m370.06,60.61l6.28,6.28,6.28-6.28c.83-.83,1.28-1.93,1.28-3.1,0-2.42-1.97-4.38-4.38-4.38-1.17,0-2.27.45-3.1,1.28l-.09.09-.09-.09c-.83-.83-1.93-1.28-3.1-1.28-2.42,0-4.38,1.97-4.38,4.38,0,1.17.45,2.27,1.28,3.1Zm3.1-5.16c.55,0,1.07.21,1.45.6l1.68,1.68.05.05.05-.05,1.68-1.68c.39-.39.91-.6,1.45-.6,1.14,0,2.06.92,2.06,2.06,0,.55-.21,1.07-.6,1.46l-4.64,4.64-4.64-4.64c-.39-.39-.6-.91-.6-1.46,0-1.14.92-2.06,2.06-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m376.34,45.7c-3.57,0-6.93,1.39-9.45,3.91-2.52,2.52-3.91,5.88-3.91,9.45s1.39,6.93,3.91,9.45c2.52,2.52,5.88,3.92,9.45,3.92s6.93-1.39,9.45-3.92,3.91-5.88,3.91-9.45-1.39-6.93-3.91-9.45c-2.52-2.52-5.88-3.91-9.45-3.91Zm7.76,21.12c-2.07,2.07-4.83,3.21-7.76,3.21s-5.68-1.14-7.76-3.21c-2.07-2.07-3.21-4.83-3.21-7.76s1.14-5.68,3.21-7.76c2.07-2.07,4.83-3.21,7.76-3.21s5.68,1.14,7.76,3.21c2.07,2.07,3.21,4.83,3.21,7.76s-1.14,5.68-3.21,7.76Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2e65ad00c989c8b90f8d9672d96a870c.svg";
export { ForwardRef as ReactComponent };